/* Component Dependencies */
var cardCarouselTemplate = require('templates/cardCarousel.hbs');
var cardCarouselDestinationTemplate = require('templates/cardCarousel-destination.hbs');
var AriesComponent = require('libs/aries-component');
var mobileFirstPicture = require('content_libs/mobileFirstPicture');

AriesComponent.create({

  type: 'cardCarousel',

  template: {
    'cardCarousel': cardCarouselTemplate,
    'cardCarousel-destination' : cardCarouselDestinationTemplate
  },
  init: function() {
   
  },
  unBindEvents: function($) {
    $('*[data-component-id="' + this.$el.data('component-id') + '"]').off();
    $('*[data-component-id="' + this.$el.data('component-id') + '"] *').off();
  },

  bindEvents: function() {
    var _self = this;
     _self.captionHandler();
     _self.onSlickInit.call(_self);
     mobileFirstPicture.init(_self); 
  },
  onSlickInit: function _onSlickInit() {
    var _self = this;
    _self.$el.find('.slick-current').focus();
    setTimeout(function() {
      _self.carouselCaption.call(_self);
    }, 1000);
  },
  captionHandler: function () {
    var _self = this;

    $(window).on('resize',_self, function() {
      var $carousel = $('.mi-carousel').find('.m-carousel-caption');
      if(window.innerWidth <= 600){
        $carousel.addClass('l-drawer-opened').removeClass('l-drawer-closed');
      }
      else{
        if ($('.mi-gallery-info-button').hasClass('t-icon-minus')){
          $carousel.addClass('l-drawer-opened').removeClass('l-drawer-closed');
        }
        else{
          $carousel.addClass('l-drawer-closed').removeClass('l-drawer-opened');
        }
      }
      _self.carouselCaption.call(_self);

    });

    //Marketing caption - on click of + / - buttons
    $('.mi-gallery-info-button').off('click').on('click', function(e) {
        e.preventDefault();
        var $this = $(this),
            $messageInfo = $this.next('.m-marketing-info'),
            $carousels = $this.parents('.mi-carousel'),
            $carouselButton = $carousels.find('.mi-gallery-info-button'),
            $viewportWidth = window.innerWidth;
            
        if ($this.hasClass('t-icon-minus')) {
          $carouselButton.toggleClass('t-icon-minus t-icon-plus');
          $carouselButton.next('.m-marketing-info').css('opacity', '0');
          if($viewportWidth > 600){
            $carousels.find('.m-carousel-caption').addClass('l-drawer-closed').removeClass('l-drawer-opened');
          }
        } else {
          $carouselButton.toggleClass('t-icon-plus t-icon-minus');
          $carouselButton.next('.m-marketing-info').css('opacity', '0.9');
          if($viewportWidth > 600){
            $carousels.find('.m-carousel-caption').addClass('l-drawer-opened').removeClass('l-drawer-closed');
          }
        }
      });

  },
  carouselCaption: function() {
    var _self = this;
    if(_self.$el.length > 0){
      var $imgContainerRight = _self.$el[0].getBoundingClientRect().right;
      var $padding;
    
      _self.$el.find('.m-carousel-caption').each(function(i, obj){
        var $captionContainerRight = obj.getBoundingClientRect().right;
        if( $captionContainerRight > $imgContainerRight ){
          $padding = $captionContainerRight - $imgContainerRight +20; 
        }
      });
      _self.$el.find('.m-carousel-caption').css('padding-right', $padding);
    }
  }
});

//use this for testing in local
//$(document).trigger('GLOBAL_ELEMENTS_REINIT');
